import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import 'element-ui/lib/theme-chalk/index.css'
// import '@/styles/theme/index.css'
import ElementUI from 'element-ui'

import '@/styles/index.scss' // global css

import '@/icons' // icon

import App from './App'
import router from '@/router'
import store from '@/store'
import '@/directive/index'

import i18n from '@/lang' // internationalization
import '@/utils/globalAuthChannel'

// set ElementUI lang to EN
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
// 引入 ErrorMsgDialog组件
import ErrorMsgDialog from '@/components/ErrorMsgDialog/index'
Vue.use(ErrorMsgDialog)
Vue.config.productionTip = false

const vue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
// console.log('environment', process.env.VUE_APP_BASE_API)
export default vue
